'use client';

import getEnv from '@/utils/env/client';

export function AppName() {
  return <>{getEnv('APP_NAME') || 'Redi Rooms'}</>;
}
